import type {ControlledTooltipProps} from '@github-ui/portal-tooltip/controlled'
import {usePortalTooltip} from '@github-ui/portal-tooltip/use-portal-tooltip'
import type {LabelProps} from '@primer/react'
import {Label} from '@primer/react'
import {clsx} from 'clsx'
import React from 'react'

import styles from './CommentHeaderBadge.module.css'

type Props = LabelProps & {
  label: string
  ariaLabel: string
  className?: string
  testId: string
  viewerDidAuthor?: boolean
  leadingElement?: React.ReactNode
  tooltipDirection?: ControlledTooltipProps['direction']
}

export const CommentHeaderBadge: React.FC<Props> = ({
  label,
  ariaLabel,
  testId,
  viewerDidAuthor,
  variant,
  leadingElement,
  className,
  tooltipDirection,
}: Props) => {
  const contentRef = React.useRef<HTMLDivElement>(null)
  const [buttonContentProps, buttonTooltipElement] = usePortalTooltip({
    contentRef,
    'aria-label': ariaLabel,
    ...(tooltipDirection && {direction: tooltipDirection}),
  })
  return (
    <Label
      variant={variant || 'secondary'}
      data-testid={testId}
      aria-label={ariaLabel}
      className={clsx(viewerDidAuthor && styles.viewerDidAuthor, className)}
      ref={contentRef}
      {...buttonContentProps}
    >
      {leadingElement}
      {label}
      {buttonTooltipElement}
    </Label>
  )
}
